import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { BinCardProvider } from '../facility/binCard/ContextAPI';
import Index from '../facility/binCard/Index';
import PermissionDenied from './PermissionDenied';

export default function FacilityBinCard() {
    // Route Permission
    const { auth } = useAuth();
    const { route_permissions } = auth;
    if (!route_permissions['facility-bin-card']) return <PermissionDenied />;

    return (
        <BinCardProvider>
            <Index />
        </BinCardProvider>
    );
}
